export default __webpack_public_path__ + "media/images/manual/ic/07-f177301d419c702d6676632c66888981.png";